import { Type } from "@shared/ui/Type";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { useBreakpoint } from "@shared/hooks/useBreakpoint";
import PanelTitle from "@shared/ui/PanelTitle";

export type Props = {
  onContinue: () => void;
  onBack: () => void;
};

export function FriendInvitationUnsure({ onBack, onContinue }: Props) {
  const isMdScreen = useBreakpoint("md");

  return (
    <PanelTitle
      title="Not Sure Who to Invite?"
      description="If you don't know who to invite right now, you can still invite a friend by July, 2025."
      className="flex-1"
    >
      <Type variant="body1" className="text-brand-800 md:text-brand-100">
        And even if you don't invite a friend, we'll still place you in a great
        group of aligned peers. You can manage your invitation in Program &gt;
        Invites
      </Type>
      <ActionButtonsGroup
        theme={!isMdScreen ? "dark" : "light"}
        onPrimaryClick={onContinue}
        primaryButtonText={"Continue"}
        onSecondaryClick={onBack}
        secondaryButtonText={"Back"}
        primaryButtonProps={{ className: "w-full md:w-auto" }}
        secondaryButtonProps={{ className: "w-full md:w-auto" }}
      />
    </PanelTitle>
  );
}

export default FriendInvitationUnsure;
